import { UserServiceActionTypes } from '../User/User.types'
import * as ExerciseTypes from './Exercise.types'
import { getUniqueEntities } from './Exercise.utils'

export const exerciseServiceInitialState: ExerciseTypes.ExerciseServiceInitialState = {
  entities: [],
  wordBuilderEntities: [],
  sentenceBuilderEntities: [],
  loadedExercisesBookIds: [],
  difficultWords: [],
  masteredWordsCount: 0,
  studySets: [],
  currentStudySetId: null
}

export const exerciseReducer = (
  state: ExerciseTypes.ExerciseServiceInitialState = exerciseServiceInitialState,
  action: ExerciseTypes.ExerciseServiceActions
) => {
  switch (action.type) {
    case UserServiceActionTypes.LOGOUT: {
      return exerciseServiceInitialState
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncGetAllByBookId: {
      return {
        ...state,
        entities: getUniqueEntities(state.entities, action.exerciseEntities),
        loadedExercisesBookIds: [...state.loadedExercisesBookIds, action.bookId]
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncGetDifficultWordsAndMasteredCount: {
      return {
        ...state,
        difficultWords: action.difficultWords,
        masteredWordsCount: action.masteredCount
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncGetStudySets: {
      return {
        ...state,
        studySets: action.studySets
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncCreateNewStudySet: {
      return {
        ...state,
        studySets: [...state.studySets, action.studySet],
        currentStudySetId: action.studySet._id
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncUpdateSingleStudySet: {
      const studySetsWithoutUpdated = state.studySets.filter(({ _id }) => _id !== action.studySet._id)
      return {
        ...state,
        studySets: [...studySetsWithoutUpdated, action.studySet],
        currentStudySetId: action.studySet._id
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncDeleteStudySet: {
      return {
        ...state,
        studySets: state.studySets.filter(({ _id }) => _id !== action.setId),
        currentStudySetId: state.currentStudySetId === action.setId ? null : state.currentStudySetId
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.SetCurrentStudySetId: {
      return {
        ...state,
        currentStudySetId: action.setId
      }
    }

    case ExerciseTypes.ExerciseServiceActionTypes.AsyncGetMultipleByType: {
      if (action.exerciseType === ExerciseTypes.ExerciseType.SentenceBuilder) {
        return {
          ...state,
          sentenceBuilderEntities: getUniqueEntities(state.sentenceBuilderEntities, action.exerciseEntities)
        }
      }

      return {
        ...state,
        wordBuilderEntities: getUniqueEntities(state.wordBuilderEntities, action.exerciseEntities)
      }
    }
    default:
      return state
  }
}
